import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'courseDocuments': [],
  'loading': false,
  'error': null,
};

export const wtsCourseDocuments = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_COURSE_DOCS]: (state) => ({
      ...state,
      'loading': true,
      'error': null,
    }),
    [ActionTypes.FETCHED_WTS_COURSE_DOCS]: (state, action) => ({
      ...state,
      'loading': false,
      'courseDocuments': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_COURSE_DOCS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'courseDocuments': [],
      'error': action.payload,
    }),
    [ActionTypes.CREATING_WTS_COURSE_DOC]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.CREATED_WTS_COURSE_DOC]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATED_WTS_COURSE_DOC_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'error': action.payload,
    }),
    [ActionTypes.UPDATING_WTS_COURSE_DOC]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.UPDATED_WTS_COURSE_DOC]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.UPDATED_WTS_COURSE_DOC_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'error': action.payload,
    }),
    [ActionTypes.DELETING_WTS_COURSE_DOC]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETED_WTS_COURSE_DOC]: (state) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.DELETED_WTS_COURSE_DOC_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'error': action.payload,
    }),
    [ActionTypes.FETCHING_WTS_COURSE_DOC_FILE]: (state) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_COURSE_DOC_FILE]: (state, action) => ({
      ...state,
      'loading': false,
      'currentDocFile': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_COURSE_DOC_FILE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'currentDocFile': null,
      'error': action.payload,
    }),
    [ActionTypes.CLEAR_WTS_COURSE_DOCS]: (state) => ({
      ...state,
      'courseDocuments': [],
      'currentDocFile': null,
    }),
  })(state, action);
};
